<script>
    // Props
    export let emotion = '';
    export let color = '';
    export let textColor = '';
    export let isToggled = true;
    export let isGrayedOut = false;
    
    // Component level
    let ref;

    const capitalizeFirstLetter = (val) => {
        return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }

    const activeStyle = `
        border: 2px solid ${color};
        background-color: ${ color }F5;
        color: ${textColor};
    `

    const inactiveStyle = `
        border: 2px solid ${ color };
        background-color: ${ color }1a;
        color: ${ textColor != '#222' ? '#222' : textColor };
    `
</script>

<div>

    <button 
        class="filter-button" 
        style={ isGrayedOut ? inactiveStyle : ( isToggled ? activeStyle : inactiveStyle) }
        on:click={ (e) => { 
            if (!isGrayedOut) {
                isToggled = !isToggled 
            }
        } }
        on:mouseenter={ (e) => { 
            if (!isGrayedOut) {
                e.target.style = isToggled ? inactiveStyle : activeStyle  
            }
        } }
        on:mouseleave={ (e) => {
            if (!isGrayedOut) {
                e.target.style = isToggled ? activeStyle : inactiveStyle 
            } 
        }}
        bind:this={ref}
        disabled={ isGrayedOut }
    >{ capitalizeFirstLetter(emotion) }</button>
</div>